<template>
  <div class="surewrap" v-show="ApplyInfo.isShow">
    <div class="surepop">
      <h4>
        {{ ApplyInfo.title }}
        <img @click="close" src="~img/Group 30@2x.png" alt="" />
      </h4>
      <div class="surecon">
        {{ ApplyInfo.content }}
      </div>
      <p class="mainhint">{{ ApplyInfo.hint }}</p>
      <div class="optionbox clearfix">
        <button class="fl" @click="passbind">{{ ApplyInfo.sure }}</button>
        <button class="fr iscancel" @click="canclepass">
          {{ ApplyInfo.cancle }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ApplyInfo: {
      type: Object,
      default: function() {
        return {
          isShow: false,
          title: "绑定申请",
          content: "申请绑定的用户昵称申请成为您的子账户，是否通过申请？",
          hint: "* 同意申请将有可能泄露您的隐私，一旦绑定无法撤销",
          sure: "通过",
          cancle: "驳回"
        };
      }
    }
  },
  methods: {
    close() {
      this.ApplyInfo.isShow = false;
    },
    passbind() {
      this.ApplyInfo.isShow = false;
      this.$emit("passbind", true);
    },
    canclepass() {
      this.ApplyInfo.isShow = false;
      this.$emit("passbind", false);
    }
  }
};
</script>

<style lang="stylus" scoped>
.surewrap
    background rgba(0, 0, 0, 0.5)
    width 100%
    height 100%
    position fixed
    top 0px
    left 0px
    z-index 200
    .surepop
        width 285px
        padding 0px 24px 28px
        height 180px
        background rgba(255, 255, 255, 1)
        border-radius 8px
        position absolute
        left 0
        right 0
        top 0
        bottom 0
        margin auto
        h4
            height 53px
            line-height 53px
            font-size 18px
            font-weight 400
            color rgba(51, 51, 51, 1)
            text-align center
            position relative
            border-bottom 1px solid #EEEEEE
            img
                position absolute
                right 0
                top 0
                bottom 0
                margin auto 0
                width 14px
                height 14px
        .surecon
            font-size 16px
            font-family PingFangSC
            font-weight 400
            color rgba(51, 51, 51, 1)
            line-height 26px
            margin-top 16px
        .mainhint
            font-size 10px
            font-family PingFangSC
            font-weight 400
            color rgba(255, 0, 0, 1)
            line-height 17px
            margin 15px 0
        button
            width 124px
            height 34px
            font-size 14px
            background #48a2df
            border-radius 4px
            color #fff
            border none
            &.iscancel
                width 124px
                height 34px
                background rgba(202, 213, 216, 1)
                border-radius 4px
</style>
